import { StateSchema } from 'app/config/storeConfig/types';

export const getSelectedWarehouses = (state: StateSchema): string[] => state.createUserModal.selectedWarehouses;
